// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1QNW_","cell":"ColumnAccessor_cell__1dq85","firstCellAccent":"ColumnAccessor_firstCellAccent__1qEgL"};